import _Calendar from './Calendar';

import './style/index.js';

export type { CalendarProps, CalendarMethods } from './Calendar';
export * from './type';

export const Calendar = _Calendar;
export default Calendar;
